import { ExpertiseColumn } from 'widgets/expertise/ExpertiseColumnDefinitions';
import { SortModel, SortDirection } from '@instinet-analytics/core-lib';
import { GridFiltersState } from 'widgets/store/grid/filters/FilterState';
import { ConfigStateWithGridSupport } from 'widgets/store/grid/reducer';
import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';

export interface ExpertiseConfigurationState
    extends ConfigStateWithGridSupport<ExpertiseColumn>,
        GridFiltersState<ExpertiseColumn>,
        WidgetConfigWithHideableToolbar {}

export const initialExpertiseSort: SortModel<ExpertiseColumn> = [
    { colId: 'dateTime', sort: SortDirection.DESCENDING },
];

export const initialExpertiseConfiguration: ExpertiseConfigurationState = {
    columnWidths: {},
    visibleColumns: ['dateTime', 'orderId', 'venueName', 'size', 'price'],
    filters: [],
    sort: initialExpertiseSort,
};
